import React from 'react'
import personUploading from '../../../../../../../assets/images/spa/person_uploading.svg'
import personSearching from '../../../../../../../assets/images/spa/person_searching.svg'
import { Button } from 'spa/member/components/Button'
import { Link } from 'react-router-dom'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'
import { breakpoints } from 'spa/config/styled'
import styles from './UserRegistrationFinish.module.scss'

export const StyledRegistrationFinish: React.FC = () => {
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth < breakpoints.md

  return (
    <div className={`flex-grow flex flex-col items-center tablet:p-4XL pb-M ${styles.container}`}>
      <h1 className={`text-center font-normal text-2XL tablet:text-4XL ${styles.title}`}>会員登録完了</h1>
      <div className="py-2XL text-S leading-6 text-start tablet:text-center">
        この度はクラウドワークス テックにご登録いただきまして、誠にありがとうございます。
        <br />
        <strong>
          職務経歴書やポートフォリオを提出することで、
          {isMobile ? <br /> : null}
          あなたにマッチした案件をいち早く紹介できます。
        </strong>
      </div>
      <div className="flex justify-center gap-2XL flex-wrap w-full">
        <LinkArea
          topText={
            <>
              職務経歴書やポートフォリオをお持ちの場合、<br />
              アップロードページからファイルを{isMobile ? <br /> : null}アップしてください。
            </>
          }
          image={personUploading}
          buttonText="ファイルをアップロードする"
          path="/profile_sheet/resume_files"
        />
        <LinkArea
          topText={
            <>
              ご入力内容から、最適な案件を厳選。<br />
              あなただけのおすすめ案件をご提案します。
            </>
          }
          image={personSearching}
          buttonText="おすすめの案件を確認する"
          path="/recommended_job_offers"
        />
      </div>
      <a href="/dashboard" className={`text-tech-apple-green-90 text-S font-bold underline tracking-wide ${styles.bottomLink}`}>マイページTOPへ</a>
    </div>
  )
}

const LinkArea: React.FC<{ topText: React.ReactNode, image: string, buttonText: string, path: string }> = ({ topText, image, buttonText, path}) => {
  return (
    <div className={`flex flex-col justify-center items-center bg-gray-100 px-M tablet:px-2XL py-2XL ${styles.linkArea}`}>
      <div className="text-S font-bold leading-6 text-center">
        {topText}
      </div>
      <img src={image} width="110px" height="112px" className="py-XL box-content" />
      <Link to={path} className="w-full text-center">
        <Button className={`bg-tech-apple-green-60 text-white text-S font-bold p-M hover:opacity-70 ${styles.button}`}>
          {buttonText}
        </Button>
      </Link>
    </div>
  )
}
